import Api from './api';

export interface OrderItem {
    id: number | string;
    name: string;
    qty: number;
    price: number;
    sauces: string[];
    sideDish: string | null;
    sideDishes: string[];
    flavors: string[];
    additionals: string[];
    salads: string[];
    desserts: string[];
    removedIngredients: string[];
    observations?: string;
}

export interface CreateOrderData {
    storeId: string;
    customerName: string;
    phone: string;
    address: string;
    referencePoint: string;
    observations?: string;
    deliveryMode: 'entrega' | 'retirada' | 'comanda';
    payment: string;
    changeValue?: string;
    items: OrderItem[];
    subtotal: number;
    deliveryFee: number;
    total: number;
}

export interface Order {
    _id: string;
    id?: string;
    storeId: string;
    customerName: string;
    phone: string;
    status: string;
    total: number;
    orderNumber?: string;
    createdAt: string;
}

export interface CreateOrderResponse {
    success: boolean;
    message: string;
    order: Order;
}

export interface ComandaAccessData {
    storeId: string;
    phone: string;
    mesaNumber?: number;
    customerName?: string;
    password?: string;
}

const create = async (orderData: CreateOrderData): Promise<CreateOrderResponse> => {
    const { data } = await Api.post<CreateOrderResponse>('/orders', orderData);
    return data;
};

const accessComanda = async (accessData: ComandaAccessData): Promise<any> => {
    const { data } = await Api.post('/comandas/access', accessData);
    return data;
};

const addOrderToComanda = async (comandaId: string, orderData: any): Promise<any> => {
    const { data } = await Api.post('/comandas/add-order', { comandaId, orderData });
    return data;
};

const clientFinalized = async (orderId: string): Promise<void> => {
    await Api.patch(`/orders/${orderId}/client-finalized`, {});
};

const getMesaStatus = async (storeId: string, mesaNumber: string): Promise<{ ocupada: boolean; comandaId?: string }> => {
    const { data } = await Api.get(`/comandas/mesa-status?storeId=${storeId}&number=${mesaNumber}`);
    return data;
};

const simplesAccess = async (payload: { storeId: string; mesaNumber: number; customerName?: string; phone?: string }): Promise<any> => {
    const { data } = await Api.post('/comandas/simples-access', payload);
    return data;
};

const cartaoAccess = async (payload: { storeId: string; cartaoCode: string; customerName?: string; phone?: string }): Promise<any> => {
    const { data } = await Api.post('/comandas/cartao-access', payload);
    return data;
};

const getComandaByIdClient = async (id: string, senha: string): Promise<any> => {
    const { data } = await Api.get(`/comandas/client/${id}?senha=${encodeURIComponent(senha)}`);
    return data;
};

const getComandaByCartao = async (storeId: string, code: string): Promise<any> => {
    const { data } = await Api.get(`/comandas/by-cartao/${code}?storeId=${storeId}`);
    return data;
};

export const OrderService = {
    create,
    accessComanda,
    addOrderToComanda,
    clientFinalized,
    getMesaStatus,
    simplesAccess,
    cartaoAccess,
    getComandaByIdClient,
    getComandaByCartao,
};
